<template>
    <component 
        :is='componente' 
        :componente="componente" 
        :empresa-id="empresaId"
        :ref="componente"
        @update="update"
    />
</template>
<script>
export default {
    components: {
        'rol': () => import('./accordions/rol'),
        'selic': () => import('./accordions/selic'), 
        'anexo2': () => import('./accordions/anexo2'),
        'anexo6_1': () => import('./accordions/anexo6_1'),
        'anexo6_2': () => import('./accordions/anexo6_2'),
        'grafico': () => import('./accordions/grafico'),
    },
    props: {
        componente: {
            type: String,
            default: null
        },
        empresaId: {
            default: null
        },
    }, 
    methods : {
        montar(tela){
            /* eslint-disable */
            try{
                this.$refs[tela].montar();
            }catch(e){
            }
        },
        update() {
            this.$emit('update'); 
        },
    }
    
}
</script>
<style lang="">
    
</style>